import React, { Component } from "react"
import { MDBBtn, MDBIcon } from "mdbreact"
import ApiRest from "../../ayudas/apiRest"
import _valid from "../../validations"
import { Card, Collapse, CardTitle, CardBody, Col, Container, Media, Label, Input, Row } from 'reactstrap'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import ReactApexChart from "react-apexcharts"
import { Link } from "react-router-dom"
import toastr from "toastr"
import Select from 'react-select';
import { Pie } from 'react-chartjs-2'
import 'chart.piecelabel.js';



export default class graficaCalificacion extends Component {
    constructor(props) {
        super(props);

        this.apiRest = new ApiRest();

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                titulo: "",
                descripcion: "",
                url_img_ns: "url_temp",
                img_nueva_solicitud: null,
                estado: 0,
                prioridad: 0,
                solicitar_a: null,
                lugar_ubicacion: null,
                tipo_solicitud: null,
                proyecto: null,
                colaborador: null,
                fecha_programada: null,
                fecha_fin: null,
                horas: 0,
                razon_rechazo: null,
                valor: 0,
                img_calificacion: null
            },
            fechaFin: null,
            fechaMin: null,
            solicitar_a: null,
            lugar_ubicacion: null,
            tipo_solicitud: null,
            ubicaciones: [],
            tiposSolicitudes: [],
            departamentosAreas: [],
            colapsar: true,
            solicitudes: [],
            serie:[],
            options:[],
            data: [],
            opciones: [],
            colores: ["#ff6600", "#e5be01", "#C70039", "#572364", "#00FF00"],
            etiqueta:[ "Rechazado","Malo","Regular","Bueno","Excelente"],
        };
        this.buscar = this.buscar.bind(this);
        this.getInformacion = this.getInformacion.bind(this);
        this.borrarFiltros = this.borrarFiltros.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);

    }

    componentDidMount() {
        localStorage.removeItem("datos");
        let id = null;
        
        if(this.apiRest.getRol()){
            this.getInformacion();
        }else{
            id = this.apiRest.getLS('du').colaborador.id;
            this.obtenerDepartamentoLoggeado(id);
        }
    }

    configuracionGrafica(){
        const{
            serie,
            colores,
            etiqueta
        } = this.state;
        let total = 0;
        serie.forEach(e =>{
            if(_valid(e)){
                total += e;
            }
        })
        const data = {
            labels: [
                "Rechazado: "+Math.trunc((serie[0]* 100)/total)+'%', 
                "Malo: "+Math.trunc((serie[1]* 100)/total)+'%', 
                "Regular: "+Math.trunc((serie[2]* 100)/total)+'%', 
                "Bueno: "+Math.trunc((serie[3]* 100)/total)+'%', 
                "Excelente: "+Math.trunc((serie[4]* 100)/total)+'%'
            ],
            datasets: [{
                data: serie,
                backgroundColor: colores
            }]
        };
        const opciones = {
            responsive: true,
            maintainAspectRation: true,
            pieceLabel: {
                render: function (args) {
                    return etiqueta[args.index]+' '+ Math.trunc((args.value * 100) / total)+'%' 
                },
                fontSize: 12.8,
                fontColor: '#110700',
                fontFamily: 'Tahoma'
            }
        }
        
        this.setState({ data: data, opciones: opciones });
    }

    obtenerDepartamentoLoggeado = (id) => {
        if(_valid(id)){
            this.apiRest.get('/departamentoLoggeado/'+id).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ departamentosAreas: this.formatoLabel(resultado) });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    cambiosSolicitarA = asignado => {
        this.setState({ solicitar_a: asignado });
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            ...estadoAnterior, [name]: value
        }));
    }

    //formatear la seleccion
    formato = valores => valores.data.map(i => ({ value: i.id, label: i.texto_area }));
    formatoLabel = valores => valores.data.map(i => ({ value: i.id_departamento, label: i.departamento }));

    //traer informacion para los select de la vista
    getInformacion = () => {
        //obtener departamento
        this.apiRest.get('/departamentoArea').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentosAreas: this.formato(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    //valida si todos los campos estan vacios
    validar = (filtro) => {
        let boleano = false;
        
        if(_valid(filtro.fechaFin, filtro.fechaMin)){
            boleano = true
        }
        if(_valid(filtro.solicitar)){
            boleano = true
        }
        return boleano;
    }

    //metodo para extraer los valores de los estados para usar en la grafica
    valor = (solicitudes) => {

        let valores = [0, 0, 0, 0, 0];
        if (Object.keys(solicitudes).length === 0) {
            toastr.error('Vaya! No se encontro informacion, por favor intenta nuevamente.');
        } else {
            toastr.success('Procesando solicitud espere un momento por favor');
            solicitudes.forEach(function (solicitud, index) {
                switch (solicitud.valor) {
                    case 1:
                        //no asignado
                        valores[0] += 1;
                        break;
                    case 2:
                        //asignado
                        valores[1] += 1;
                        break;
                    case 3:
                        //planificado
                        valores[2] += 1;
                        break;
                    case 4:
                        //concluido
                        valores[3] += 1;
                        break;
                    case 5:
                        //aceptado
                        valores[4] += 1;
                        break;
                    default:
                        break;
                }
            });
        }
        this.setState({ serie: valores });
    }

    //metodo para buscar la data filtrada
    buscar = async () => {
        const {
            fechaMin,
            fechaFin,
            solicitar_a,
            lugar_ubicacion,
            tipo_solicitud
        } = this.state
        let solicitar = null;
        let lugar = null;
        let tipo = null;
        if (solicitar_a !== null) {
            solicitar = solicitar_a.value;
        }

        if (lugar_ubicacion !== null) {
            lugar = lugar_ubicacion.value;
        }
        if (tipo_solicitud !== null) {
            tipo = tipo_solicitud.value;
        }

        const filtro = {
            fechaMin,
            fechaFin,
            solicitar,
            lugar,
            tipo
        }

        if (this.validar(filtro)) {
            ///solicitudFiltrar
            this.apiRest.put('/listaSolicitudPorCalificacion', filtro).then(respuesta => {
                if (respuesta.exitoso) {
                    //console.log(respuesta.data.total);
                    //this.valor(respuesta.data);
                    this.setState({ serie: respuesta.data.total });
                    window.localStorage.setItem('datos', JSON.stringify(respuesta.data.solicitudes));
                    this.configuracionGrafica();
                } else {
                    let valores = [0, 0, 0, 0, 0];
                    this.setState({ serie: valores });
                    this.props.history.push('/Timeout');
                }
            });
        } else {
            let valores = [0, 0, 0, 0, 0];
            this.setState({ serie: valores });
            window.localStorage.removeItem('datos');
            toastr.error('Seleccione una opcion, por favor e intenta nuevamente.');
        }
    }

    //descarga de excel grafica
    descargarExcel = () => {
        let result = JSON.parse(localStorage.getItem('datos'));
        //console.log(result);
        if (_valid(result)) {
            this.exportarData(result);
            localStorage.removeItem("datos");
        } else {
            toastr.error('No hay datos para procesados realize una busqueda primero');
        }
    }

    //metodo para exportar los datos a graficar
    exportarData = (datos) => {
        let array = null;
        array = datos
        if (_valid(array)) {
            const auth = this.apiRest.getLS('authUser');
            if (auth !== null) {
                const headers = {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                    responseType: 'blob',
                    body: JSON.stringify(datos ? datos : '')
                }
                fetch(process.env.REACT_APP_API_URL + "/graficaCalificacion/"+1, headers).then(resp => {
                    if(resp.status >= 200 && resp.status < 300){
                        resp.blob().then(blob => {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement("a");
                            a.style.display = "none";
                            a.href = url;
                            // the filename you want
                            a.download = "grafica.xlsx";
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                        });
                    }else if(resp.status === 401){
                        this.props.history.push('/Timeout');
                    }
                });
            } else {
                toastr.error('Vaya! No loggeado, por favor intenta nuevamente.');
            }
        } else {
            toastr.error('No hay datos para procesar');
        }
    }

    borrarFiltros = () =>{
        this.setState({fechaFin: null, fechaMin: null, solicitar_a: null})
        this.setState({fechaFin: '', fechaMin:'', solicitar_a: ''})
    }

    render() {
        const {
            colapsar,
            fechaMin,
            fechaFin,
            departamentosAreas,
            tiposSolicitudes,
            ubicaciones,
            solicitar_a,
            options,
            serie,
            data
        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Mesa de Servicio" breadcrumbItem="Gráfica de Calificación de Solicitudes" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Gr&aacute;fica</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, seleccione una opci&oacute;n.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <form>
                                                <div className="p-4 border-top">
                                                    <Row>
                                                        <Col lg={3}>
                                                            <Label htmlFor="fechaMin" className="form-label">
                                                                Desde la fecha
                                                            </Label>
                                                            <Input
                                                                value={fechaMin}
                                                                onChange={this.actualizarValores}
                                                                name="fechaMin"
                                                                type="date"
                                                            />
                                                        </Col>
                                                        <Col lg={3}>
                                                            <Label htmlFor="fechaFin" className="form-label">
                                                                Hasta la fecha
                                                            </Label>
                                                            <Input
                                                                value={fechaFin}
                                                                onChange={this.actualizarValores}
                                                                name="fechaFin"
                                                                type="date"
                                                            />
                                                        </Col>
                                                        <Col lg={3}>
                                                            <Label htmlFor="solicitar_a" className="form-label">
                                                               Departamento/Área
                                                            </Label>
                                                            <Select
                                                                name="solicitar_a"
                                                                options={departamentosAreas}
                                                                value={solicitar_a}
                                                                onChange={this.cambiosSolicitarA}
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                placeholder="Selecciona.."
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                noOptionsMessage={() => "No hay más opciones"}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <p />
                                                    <Row>
                                                        <Row>
                                                            <Col>
                                                                <MDBBtn className="waves-effect" color="success" onClick={this.buscar}>
                                                                    <MDBIcon icon="fas fa-search" />{' '}
                                                                    Buscar
                                                                </MDBBtn>
                                                                {' '}
                                                                <MDBBtn className="waves-effect" color="success" onClick={this.descargarExcel}>
                                                                    <MDBIcon icon="fas fa-book" />{' '}
                                                                    Exportar
                                                                </MDBBtn>
                                                                {' '}
                                                                <MDBBtn className="waves-effect" color="warning" onClick={this.borrarFiltros}>
                                                                    <MDBIcon icon="fas fa-trash-alt" />{' '}
                                                                    Borrar Filtros
                                                                </MDBBtn>
                                                            </Col>
                                                        </Row>
                                                    </Row>
                                                    {' '}
                                                </div>
                                            </form>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        
                                        <div style={{ width: '90%', height: '75%' }}>
                                            <CardTitle className="mb-4">Tipo de solicitudes</CardTitle>
                                            <Pie data={this.state.data} options={this.state.opciones} />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} className="text-end">
                                <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/dashboard') }}>
                                    <MDBIcon icon="fas fa-arrow-left" />{' '}
                                    Regresar
                                </MDBBtn>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}